import { Component, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TFMService } from 'app/mock-api/tfm.service';
import { CommonModule } from '@angular/common';
import { FuseCardComponent } from '@fuse/components/card';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'articles-type04',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, MatIconModule, MatIconModule, FuseCardComponent, DatePipe],
  templateUrl: './articles-type04.component.html',
  styleUrl: './articles-type04.component.scss'
})
export class ArticlesType04Component {

  public view: any = {
    title: ''
  }

  constructor(public _tfmService: TFMService) {

    this._tfmService.getPages().then(res => {
      this.view.pages = res;

      this._tfmService.filterBundles({ id: this.view.id, rateType: 'pps', isActive: true }, false).then(res => {
        this.view.bundle = res.content && res.content.length > 0 ? res.content[0] : null;
        this.view.images = this.view.bundle.imageUrls;

        this.view.headerImage = this.view.images[this._tfmService.getRandom(0, this.view.images.length)];

        // this._tfmService.log(this.view);
      });
      this._tfmService.log(res);
    });
  }

  // getFeaturedImage(newsletterIndex: number): string {
   
  // }
  
  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);

      this._tfmService.getNewsletters(this.view.site.agencyID, this.view.site.siteID).then(res => {
        this.view.newsletters = res;
        // console.log('Check newsletters: ', this.view.newsletters);
        // console.log(this.view.newsletters.content.images);
        // console.log('Featured Image URL:', this.getFeaturedImage());
      });

    });
  }
}
